import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface CollapseEventArgs {
  collapsed?: boolean;
}

class CollapseEvent extends EventData<Collapsible> {

  collapsed?: boolean;

  constructor({ collapsed }: CollapseEventArgs = {}) {
    super();

    this.collapsed = collapsed;
  }
}

class CollapseEventListener extends EventListener<Collapsible, CollapseEvent, CollapseEventArgs> {

  constructor() {
    super(CollapseEvent);
  }
}

export default interface Collapsible extends Mountable {

  /** @event */
  onCollapse: CollapseEventListener;

  setCollapsed(value: boolean): void;

  isCollapsed(): boolean;

}

export { CollapseEventListener, CollapseEvent };
